import React from 'react';
import { packs } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function SermonsSection() {
  return <section id="packs" aria-labelledby="packs-title" className="scroll-mt-4 bg-teal-tint py-12 md:py-20" data-id="element-193" data-mp="ge86mx9n9mct">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-194" data-mp="bkwtyfi5ibcz">
        <SectionHeading id="packs-title" eyebrow={packs.eyebrow} title={packs.title} sub={packs.sub} data-id="element-195" data-mp="6oeu9u1oh37i" />

        <ol className="mt-8 grid gap-4 md:mt-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-196" data-mp="2n31jfnic1v3">
          {packs.groups.map((g, gi) => <li key={g.label} className="rounded-xl border border-teal-tintLine bg-white p-5" data-id="element-197" data-mp="3tqrsp5i5mb11" data-mpi={gi}>
              <div className="flex items-center gap-3" data-id="element-198" data-mp="3otrufgrjqckh">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-teal font-display text-[15px] font-extrabold text-white" data-id="element-199" data-mp="3juoolu3qs2bg">
                  {gi + 1}
                </span>
                <h3 className="font-display text-[14px] font-extrabold tracking-[0.08em] text-orange-ink" data-id="element-200" data-mp="1i2aal64bji0b">{g.label}</h3>
              </div>
              <ul className="mt-4 space-y-3" data-id="element-201" data-mp="34xjvzjx3k92b">
                {g.items.map(p => <li key={p.n} className="flex items-baseline gap-3" data-id="element-202" data-mp="39z9bpcv9lawq">
                    <span className="font-display text-[1.4rem] font-extrabold leading-none text-orange" data-id="element-203" data-mp="2v1gu8f65qcfw">{p.n}</span>
                    <span className="font-display text-[15px] font-bold leading-snug text-teal" data-id="element-204" data-mp="301388qtt7wpr">{p.title}</span>
                  </li>)}
              </ul>
            </li>)}
        </ol>
      </div>
    </section>;
}